"use client";

import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

export default function SellHighlightedTestimonial() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        color: "white",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <StarIcon sx={{ color: "gold", fontSize: 40 }} />
        <StarIcon sx={{ color: "gold", fontSize: 40 }} />
        <StarIcon sx={{ color: "gold", fontSize: 40 }} />
        <StarIcon sx={{ color: "gold", fontSize: 40 }} />
        <StarIcon sx={{ color: "gold", fontSize: 40 }} />
      </Box>
      <Typography variant="h6">
        I sold my horse 6 hrs after listing it. Cant ask for better than that.
      </Typography>
      <Box sx={{
        textAlign: "center",
      }}>
        <Typography>Tracy Boyle, NSW</Typography>
        <Typography variant="caption">member since 2013</Typography>
      </Box>
    </Box>
  );
}
